import React from "react"

import styles from "./service-contact.module.css"

export default function ServiceContact({ children }) {
  return <div className={styles.serviceContact}>{children}</div>
}
